export default {
  setModules(state, modules) {
    state.modules = modules;
  },
  setModule(state, module) {
    state.module = module;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setSelectedModule(state, selectedModule) {
    state.selectedModule = selectedModule;
  }
};
